import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import OnboardingTour from "./OnboardingTour";
import SectionTabs from "./SectionTabs";

export default function AppShell() {
    return (
        <div className="flex h-screen bg-white">
            <Sidebar />
            <div className="flex flex-1 flex-col overflow-hidden">
                <TopBar />
                <main className="flex-1 overflow-y-auto bg-neutral-50/40">
                    <div className="mx-auto max-w-6xl px-10 py-10">
                        <SectionTabs />
                        <Outlet />
                    </div>
                </main>
            </div>
            <OnboardingTour />
        </div>
    );
}
